module.exports = __webpack_public_path__ + "img/wedo_pict03.8e3e822f.png";